<cap-content-header>
  <cap-title>
    {{ "personstamm.SucheTitel" | translate }}
  </cap-title>
</cap-content-header>

<ul [(activeId)]="searchMode" #nav="ngbNav" class="nav-tabs" ngbNav>
  <li [ngbNavItem]="searchZpv()">
    <a ngbNavLink>{{ "personstamm.tab.ZPVSuche" | translate }}</a>
    <ng-template id="zpv_suche" ngbNavContent>
      <cap-personstamm-suche-zpv></cap-personstamm-suche-zpv>
    </ng-template>
  </li>
</ul>
<div [ngbNavOutlet]="nav" class="mt-2"></div>
